/**
 * Pages
 */

export * from './pages/IssueNoteDetail/IssueNoteDetail';
export * from './pages/IssueNoteCorrectionDetail/IssueNoteCorrectionDetail';
